import createOData from 'odata';

const oDataBase = {};

[
  'routeName',
  'queryName',
  'key',
  'prop',
  'i',
  'il',
  'prevHash',
  'beforeRoutingFunc',
  'overideLoading',
  'id',
  'res',
  'currentPromise',
  'arr',
  'filterStr',
  'searchFunc',
  'queryStr',
  'internalParam',
  'routeStr',
  'routeRegex',
  'str',
  'resource',
  'uri',
  'query',
  'queryOriginal',
  'appendType',
  'isIn',
  'd',
  'retValue',
  'hostname',
  'isChangeset',
  'result',
  'errResponse',
  'xhr',
  'isXDomainRequest',
  'input',
  'chr1',
  'chr2',
  'chr3',
  'enc1',
  'enc2',
  'enc3',
  'enc4',
  'output',
  'string',
].forEach((name) => {
  if (!(name in window)) {
    window[name] = undefined;
  }
});

function oData(resource) {
  return createOData.call(oDataBase, resource);
}

export default oData;
